import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { getCartContents, isShopProduct } from '../cartContents';
import calculateProductPriceWithoutQuantity from '../gaCartPriceCalc';
import { pushToDataLayer } from '../gaTracker';
import { getSectionCategorySubCat } from '../getSectionCategorySubCat';
export var newCartInfoGA = function newCartInfoGA(cartInfo) {// const ecommerceObj = {
  //   ecommerce: {
  //     newCart: {
  //       priceInfo: {
  //         ...cartInfo?.Price,
  //       },
  //       promoCode: {
  //         ...cartInfo?.OloDiscount
  //       },
  //       cart: cartInfo?.cart?.map((cartLine, index) => {
  //         const product = cartLine.Product
  //         const categories =  getSectionCategorySubCat(product.DetailLink)
  //         return {
  //           name: product.DisplayName,
  //           id: product.ProductChainId,
  //           price: cartLine.LineCost,
  //           quantity: cartLine.Quantity,
  //           section: categories[0] || '',
  //           category: categories[1] || '',
  //           'sub-category': categories[2] || '',
  //           //Not available at this time
  //           list: '',
  //           position: index+1
  //         }
  //       })
  //     }
  //   }
  // };
  //Dont do this
  //pushToDataLayer(ecommerceObj);
}; //Input array of Products

export var impressionsGA = function impressionsGA() {
  var impressions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var ecommerceObj = {
    event: 'productImpression',
    ecommerce: {
      impressions: impressions === null || impressions === void 0 ? void 0 : impressions.map(function (product, index) {
        var categories = getSectionCategorySubCat(product === null || product === void 0 ? void 0 : product.DetailLink);
        return {
          name: product === null || product === void 0 ? void 0 : product.DisplayName,
          id: (product === null || product === void 0 ? void 0 : product.ProductChainId) || (product === null || product === void 0 ? void 0 : product.ProductId),
          price: product === null || product === void 0 ? void 0 : product.AdjustedPrice,
          section: categories[0] || '',
          category: categories[1] || '',
          'dimension1': categories[2] || '',
          'dimension2': categories[3] || '',
          'dimension3': 'In Stock',
          'dimension5': (product === null || product === void 0 ? void 0 : product.CatalogName) || '',
          'dimension6': 'Regular Price',
          'variant': (product === null || product === void 0 ? void 0 : product.ProductVariantModel) || '',
          'list': 'PLP',
          position: index + 1
        };
      })
    }
  };
  pushToDataLayer(ecommerceObj);
}; //Input array of Promo Products for Carousel cards

export var promoImpressionsGA = function promoImpressionsGA() {
  var impressions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isLoggedIn = arguments.length > 1 ? arguments[1] : undefined;
  var cartContents = arguments.length > 2 ? arguments[2] : undefined;
  var promoObj = {
    'event': 'promoImpression',
    'loggedIn': isLoggedIn,
    'cartContents': cartContents,
    // ex: { cater | eat | shop }
    'ecommerce': {
      'promoView': {
        'promotions': impressions === null || impressions === void 0 ? void 0 : impressions.map(function (product, index) {
          return {
            id: product === null || product === void 0 ? void 0 : product.productId,
            name: product === null || product === void 0 ? void 0 : product.displayName,
            creative: "banner".concat(index),
            position: "slot".concat(index)
          };
        })
      }
    }
  };
  pushToDataLayer(promoObj);
}; //Input array of Promo Products for Carousel cards

export var upsellImpressionsGA = function upsellImpressionsGA() {
  var impressions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isLoggedIn = arguments.length > 1 ? arguments[1] : undefined;
  var cartContents = arguments.length > 2 ? arguments[2] : undefined;
  var promoObj = {
    'event': 'promoImpression',
    'loggedIn': isLoggedIn,
    'cartContents': cartContents,
    // ex: { cater | eat | shop }
    'ecommerce': {
      'promoView': {
        'promotions': impressions === null || impressions === void 0 ? void 0 : impressions.map(function (product, index) {
          return {
            id: product === null || product === void 0 ? void 0 : product.ProductId,
            name: product === null || product === void 0 ? void 0 : product.DisplayName,
            creative: "banner".concat(index),
            position: "slot".concat(index)
          };
        })
      }
    }
  };
  pushToDataLayer(promoObj);
}; //Input array of Promo Products for Recently Viewed Cards

export var promoImpressionsRV = function promoImpressionsRV() {
  var impressions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isLoggedIn = arguments.length > 1 ? arguments[1] : undefined;
  var cartContents = arguments.length > 2 ? arguments[2] : undefined;
  var promoObj = {
    'event': 'promoImpressionRV',
    'loggedIn': isLoggedIn,
    'cartContents': cartContents,
    // ex: { cater | eat | shop }
    'ecommerce': {
      'promoView': {
        'promotions': impressions === null || impressions === void 0 ? void 0 : impressions.map(function (product, index) {
          return {
            id: "un_named-promo",
            name: product === null || product === void 0 ? void 0 : product.imgAlt,
            creative: "banner".concat(index),
            position: "slot".concat(index)
          };
        })
      }
    }
  };
  pushToDataLayer(promoObj);
};
export var promoClickImpression = function promoClickImpression(promoObj) {
  pushToDataLayer({
    'event': 'promotionClick',
    'ecommerce': {
      'promoClick': {
        'promotions': [{
          'id': promoObj === null || promoObj === void 0 ? void 0 : promoObj.id,
          'name': promoObj === null || promoObj === void 0 ? void 0 : promoObj.name,
          'creative': "bottom-banner",
          'position': "position"
        }]
      }
    },
    'eventCallback': function eventCallback() {
      document.location = promoObj.destinationUrl;
    }
  });
};
export var purchaseConfirmation = function purchaseConfirmation() {
  var infoObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _infoObj$cartInfo = infoObj.cartInfo,
      cartInfo = _infoObj$cartInfo === void 0 ? {} : _infoObj$cartInfo,
      _infoObj$submitInfo = infoObj.submitInfo,
      submitInfo = _infoObj$submitInfo === void 0 ? {} : _infoObj$submitInfo,
      _infoObj$foodInfo = infoObj.foodInfo,
      foodInfo = _infoObj$foodInfo === void 0 ? {} : _infoObj$foodInfo,
      _infoObj$caterInfo = infoObj.caterInfo,
      caterInfo = _infoObj$caterInfo === void 0 ? {} : _infoObj$caterInfo,
      _infoObj$retailInfo = infoObj.retailInfo,
      retailInfo = _infoObj$retailInfo === void 0 ? {} : _infoObj$retailInfo,
      _infoObj$location = infoObj.location,
      location = _infoObj$location === void 0 ? {} : _infoObj$location,
      _infoObj$userInfo = infoObj.userInfo,
      userInfo = _infoObj$userInfo === void 0 ? {} : _infoObj$userInfo,
      _infoObj$priceInfo = infoObj.priceInfo,
      priceInfo = _infoObj$priceInfo === void 0 ? {} : _infoObj$priceInfo;
  var cartContents = getCartContents(cartInfo);

  try {
    var ecommerceObj = {
      event: 'purchaseConfirmation',
      ecommerce: {
        'purchase': {
          actionField: _objectSpread(_objectSpread({
            id: (submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.FoodOrderId) || (submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.CateringOrderId) || (submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.RetailOrderId) || '',
            caterId: (submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.CaterOrderId) || '',
            foodId: (submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.FoodOrderId) || '',
            affiliation: 'Online Store',
            type: userInfo === null || userInfo === void 0 ? void 0 : userInfo.type,
            email_sha256: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email_sha256,
            revenue: (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.Total) || ''
          }, priceInfo), {}, {
            tax: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.TaxTotal,
            shipping: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.ShippingTotal,
            'dimension8': cartContents
          }),
          products: cartInfo === null || cartInfo === void 0 ? void 0 : cartInfo.map(function (cartLine, index) {
            var product = (cartLine === null || cartLine === void 0 ? void 0 : cartLine.Product) || {};
            var categories = getSectionCategorySubCat(product.DetailLink) || [];
            var sale = "Regular Price";
            var stock = "In Stock";
            {
              (product === null || product === void 0 ? void 0 : product.AdjustedPrice) == (product === null || product === void 0 ? void 0 : product.ListPrice) ? sale = "Regular Price" : sale = "On Sale";
            }
            {
              (product === null || product === void 0 ? void 0 : product.AvailableInventory) <= 0 ? stock = "Out of Stock" : stock = "In Stock";
            }
            return {
              name: (product === null || product === void 0 ? void 0 : product.DisplayName) || '',
              id: (product === null || product === void 0 ? void 0 : product.ProductChainId) || '',
              price: isShopProduct(product.CatalogName) ? (cartLine === null || cartLine === void 0 ? void 0 : cartLine.LineCost) || (product === null || product === void 0 ? void 0 : product.AdjustedPrice) || '' : calculateProductPriceWithoutQuantity((cartLine === null || cartLine === void 0 ? void 0 : cartLine.LineCost) || (product === null || product === void 0 ? void 0 : product.AdjustedPrice) || '', (cartLine === null || cartLine === void 0 ? void 0 : cartLine.Quantity) || ''),
              quantity: (cartLine === null || cartLine === void 0 ? void 0 : cartLine.Quantity) || '',
              section: categories[0] || '',
              category: categories[1] || '',
              'sub-category': categories[2] || '',
              catalog: (cartLine === null || cartLine === void 0 ? void 0 : cartLine.CatalogName) || '',
              'dimension1': categories[2] || '',
              'dimension2': categories[3] || '',
              'dimension3': stock || '',
              'dimension4': '',
              'dimension5': (product === null || product === void 0 ? void 0 : product.CatalogName) || '',
              'dimension6': sale,
              'variant': (product === null || product === void 0 ? void 0 : product.ProductVariantModel) || '',
              //Not available at this time
              list: '',
              position: index + 1
            };
          }),
          order: _objectSpread(_objectSpread({}, userInfo), {}, {
            restaurantZip: (location === null || location === void 0 ? void 0 : location.postalcode) || '',
            restaurantName: (location === null || location === void 0 ? void 0 : location.alternate_name) || (location === null || location === void 0 ? void 0 : location.alternateName) || '',
            store_id: (location === null || location === void 0 ? void 0 : location.StoreNumber) || '',
            food: {
              deliveryType: (foodInfo === null || foodInfo === void 0 ? void 0 : foodInfo.Mode) || '',
              timeSelected: (foodInfo === null || foodInfo === void 0 ? void 0 : foodInfo.TimeWanted) || (foodInfo === null || foodInfo === void 0 ? void 0 : foodInfo.EarliestReadyTime) || ''
            },
            cater: {
              deliveryType: (caterInfo === null || caterInfo === void 0 ? void 0 : caterInfo.Mode) || '',
              timeSelected: (caterInfo === null || caterInfo === void 0 ? void 0 : caterInfo.TimeWanted) || (caterInfo === null || caterInfo === void 0 ? void 0 : caterInfo.EarliestReadyTime) || ''
            }
          })
        }
      }
    };
    pushToDataLayer(ecommerceObj);
  } catch (e) {
    console.log(e, "GA-ERROR");
  }
};
export var checkoutStep = function checkoutStep(_ref) {
  var actionField = _ref.actionField,
      _ref$cartInfo = _ref.cartInfo,
      cartInfo = _ref$cartInfo === void 0 ? [] : _ref$cartInfo;
  var cartContents = getCartContents(cartInfo);

  try {
    var ecommerceObj = {
      event: 'checkout',
      cartContents: cartContents,
      ecommerce: {
        'checkout': {
          actionField: actionField,
          products: cartInfo === null || cartInfo === void 0 ? void 0 : cartInfo.map(function (cartLine, index) {
            var product = cartLine.Product || {};
            var categories = getSectionCategorySubCat(product.DetailLink) || [];
            return {
              name: (product === null || product === void 0 ? void 0 : product.DisplayName) || '',
              id: (product === null || product === void 0 ? void 0 : product.ProductChainId) || '',
              price: isShopProduct(product.CatalogName) ? (cartLine === null || cartLine === void 0 ? void 0 : cartLine.LineCost) || (product === null || product === void 0 ? void 0 : product.AdjustedPrice) || '' : calculateProductPriceWithoutQuantity((cartLine === null || cartLine === void 0 ? void 0 : cartLine.LineCost) || (product === null || product === void 0 ? void 0 : product.AdjustedPrice) || '', (cartLine === null || cartLine === void 0 ? void 0 : cartLine.Quantity) || ''),
              quantity: (cartLine === null || cartLine === void 0 ? void 0 : cartLine.Quantity) || '',
              section: categories[0] || '',
              category: categories[1] || '',
              'sub-category': categories[2] || '',
              catalog: (cartLine === null || cartLine === void 0 ? void 0 : cartLine.CatalogName) || '',
              'dimension1': categories[2] || '',
              'dimension2': categories[3] || '',
              // 'dimension3': stock || '',
              // 'dimension4': '',
              'dimension5': (product === null || product === void 0 ? void 0 : product.CatalogName) || '',
              'dimension6': 'Regular Price',
              'variant': (product === null || product === void 0 ? void 0 : product.ProductVariantModel) || '',
              //Not available at this time
              list: '',
              position: index + 1
            };
          })
        }
      }
    };
    return pushToDataLayer(ecommerceObj);
  } catch (e) {
    console.log(e, 'CHECKOUT GA ERROR');
  }
};